import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { AlertService } from 'src/app/core/alert.service';
import { Router } from '@angular/router';
import { OpcionalApiService } from 'src/app/dao/api_opcionais.service';
import { Opcional } from 'src/app/model/opcional';

export class Ligacao {
  produto: number;
  opcional: number;
}

@Component({
  selector: 'app-opcional-produto-list',
  templateUrl: './opcional-produto-list.page.html',
  styleUrls: ['./opcional-produto-list.page.scss'],
})
export class OpcionalProdutoListPage implements OnInit {

  ligacoes: Ligacao[] = [];

  ligacao: Ligacao;

  constructor(private toast: ToastService,
              private alert: AlertService,
              private router: Router,
              private apiOpcional: OpcionalApiService) { }

ngOnInit() {
this.loadCategories();
}

ionViewWillEnter() {
this.loadCategories();
}

async loadCategories() {
this.apiOpcional.GetLigacoes().then(res => {
this.ligacoes = res;
this.toast.showSucess('Ligações obtidos com sucesso!');
}).catch(async err => {
console.log('err', err);
this.toast.showSucess('Erro ao obter Ligações');
});
}







delete(ligacao: Ligacao) {
this.alert.showConfirmDelete('Ligação', () => this.executeDelete(ligacao));
}

private async executeDelete(ligacao: Ligacao) {
try {
await this.apiOpcional.excluirLigacao(ligacao.opcional, ligacao.produto);
const index = this.ligacoes.indexOf(ligacao);
this.ligacoes.splice(index, 1);
this.toast.showSucess('Ligação excluída com sucesso!');
} catch (error) {
this.toast.showError('Ocorreu um erro ao tentar excluir a Ligação!');
}

}

}
